// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND = "Moment\u00e1lne nem\u00e1\u0161 v baz\u00e1ri \u017eiadny inzer\u00e1t na ko\u010d\u00edk, alebo nem\u00e1\u0161 spr\u00e1vne vyplnen\u00fd model ko\u010d\u00edka.";
